/*
THIS COMPONENT INCLUDING IN SIDEBAR FOR ALL ADMIN PAGES
 ---------------------------------------------*/
let Counters = (function () {

    let getCounts = () => {
        $.ajax({
            url: '/menu/counts',
            type: 'GET',
            dataType: 'JSON',
            success: (counts) => {
                setCounts(counts);
            }
        });
    };

    let setCounts = (counts) => {
        setReviewsCount(counts.reviews);
        setNewOrdersCount(counts.new_orders);
        setDiscussionsCount(counts.discussions);
        setOrdersWithoutTrackCount(counts.orders_without_track);
        setWarehouseHistoryWithoutConfirmCount(counts.warehouse_history_without_confirm);
    };

    let setDiscussionsCount = (count) => {
        if (count > 0) {
            $('.communications-new').html('new');
            $('.discussions-counter').html(count);
        }
    };

    let setReviewsCount = (count) => {
        if (count > 0) {
            $('.communications-new').html('new');
            $('.reviews-counter').html(count);
        }
    };

    let setNewOrdersCount = (count) => {
        if (count > 0) {
            $('.new-orders-counter').html(count);
        }
    };

    let setOrdersWithoutTrackCount = (count) => {
        if (count > 0) {
            $('.orders-without-track__alert').show();
            $('.orders-without-track__menu-item').show();
            $('.orders-without-track-counter').html(count);
        }
    };

    let setWarehouseHistoryWithoutConfirmCount = (count) => {
        if (count > 0) {
            $('.warehouse-new').html('new');
            $('.warehouse-counter-without-confirm').html(count);
        }
    };

    let init = () => {
        getCounts();
    };

    return {
        init: init
    };

})();

export default Counters;
